import $ from 'jquery';
import { ScrollPosStyler } from 'scrollpos-styler';
import reframe from 'reframe.js';
// // import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';
// import WebFont from 'webfontloader';
import lity from 'lity';

export default {
	init() {
		// JavaScript to be fired on all pages
		// WebFont.load({
		// 	typekit: {
		// 			id: 'zlk4lvd',
		// 	},
		// 	// google: { 
		// 	//   families: ['Work Sans:400,500,600,700'],
		// 	// }
		// });
		document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

		// Button Modal

		// CONTENT MODAL

		// var appendthis =  ('<div class="blueshift-modal-overlay js-modal-close"></div>');
		// $('a[data-toggle="bs-modal"]').on('click', function(e) {
		// 	e.preventDefault();
		// 	$('body').addClass('blueshift-modal-open');
		// 	var $btn = $(this).button('loading');
		// 		//$(".js-modalbox").fadeIn(500);
		// 	var contentmodalBox = $(this).attr('data-modal-content-id');
		// 	$('#bs_modal'+contentmodalBox).parent().append(appendthis);
		// 	$('header.with_ubermenu .navbar').css('z-index',1);
		// 	$('.blueshift-modal-overlay').fadeTo(200, 0.9);
		// 	$('#bs_modal'+contentmodalBox).fadeIn( 200 );
		// 	$btn.button('reset');
		// });
		// $('body').on('click','.js-modal-close',function(e){
		// 	e.preventDefault();
		// 	$('.blueshift-content-modal-box, .blueshift-modal-overlay').fadeOut(200, function() {
		// 		$('.blueshift-modal-overlay').remove();
		// 		$('header.with_ubermenu .navbar').css('z-index',1000);
		// 		$('body').removeClass('blueshift-modal-open');
		// 	});
		// });

		// Lity Modal
		$(document).on('click', 'a[data-modal]', function (e) {
			e.preventDefault();
			var href = $(this).attr('href');
			lity(href);
		});

		// Navbar toggler with overlay menu

		$(document).on('click', '.navbar-toggler', function (e) {
			e.preventDefault();
			$('body').toggleClass('menu-open');
		});
		$('#navbarMenu .navbar-nav>li>a').on('click', function () {
			$('body').removeClass('menu-open');
		});

		const _scrollToElement = function (selector) {
			var element = $(selector).get(0);
			if (!element)
				return;
			var navbarHeight = $('.main-header .navbar').offsetHeight || 0;
			var headerOffset = navbarHeight;
			var elementPosition = element.getBoundingClientRect().top;
			var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
			if ($('#wpadminbar').length > 0)
				offsetPosition -= $('#wpadminbar').height();
			try {
				$('html, body').animate({
					scrollTop: offsetPosition,
				}, 1000, function () {
					if (history.pushState) {
						history.pushState(null, null, selector);
					} else {
						location.hash = selector;
					}
				});
				// window.scrollTo({
				// 	top: offsetPosition,
				// 	behavior: 'smooth',
				// });

			} catch (e) {
				console.warn(e);
			}
		};

		const _scrollToHashesInHrefs = function () {
			document.querySelectorAll('a[href^="#"]:not(.tab-link)').forEach(function (el) {
				el.addEventListener('click', function (e) {
					$('body').removeClass('menu-open');
					_scrollToElement(el.getAttribute('href'));

					e.preventDefault();
					return false;
				});
			});
			if (window.location.hash) {
				_scrollToElement(window.location.hash);
			}
		};
		// SCroll spy
		const _scrollSpy = function () {
			// grab the sections (targets) and menu_links (triggers)
			// for menu items to apply active link styles to
			const sections = document.querySelectorAll('.section-scroll');
			const menu_links = document.querySelectorAll('li.scroll-nav-item a');

			// functions to add and remove the active class from links as appropriate
			const removeActive = (link) => menu_links[link].classList.remove('active');
			const removeAllActive = () => {
				for (let i = 0; i < menu_links.length; i++) {
					removeActive(i);
				}
			}
			const makeActive = (link) => {
				return menu_links[link] ? menu_links[link].classList.add('active') : false;
			};

			// change the active link a bit above the actual section
			// this way it will change as you're approaching the section rather
			// than waiting until the section has passed the top of the screen
			const sectionMargin = 100;

			// keep track of the currently active link
			// use this so as not to change the active link over and over
			// as the user scrolls but rather only change when it becomes
			// necessary because the user is in a new section of the page
			let currentActive = 0;
			removeAllActive();
			makeActive(currentActive);

			// listen for scroll events
			window.addEventListener('scroll', () => {

				const current = sections.length - Array.from(sections).reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin) - 1;

				if (current >= sections.length) {
					return;
				}

				// only if the section has changed
				// remove active class from all menu links
				// and then apply it to the link for the current section

				if (current !== currentActive) {
					removeAllActive();
					currentActive = current;
					makeActive(current);
				}
			});
		};


		//Call functions at the end
		//Reframe js
		reframe('.reframe iframe', '.reframe video');
		// Scroll to hrefs
		_scrollToHashesInHrefs();

		//Scrollpos styler
		ScrollPosStyler;
		// Scroll spy
		_scrollSpy();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
